import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoadDialogComponent } from '../load-dialog/load-dialog.component';
import { SessionBootstrapService } from 'src/app/services/session-bootstrap.service';
import { SchemeLinkService } from 'src/app/services/scheme-link.service';
import { SCHEME_LINK_PARAM } from 'src/app/services/session.service';

@Component({
    selector: 'loyale-load',
    templateUrl: './load.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadComponent implements OnInit, OnDestroy {
  dialogRef = null;

  constructor(
    private dialog: MatDialog,
    private commonService: CommonService,
    private sessionBootstrapService: SessionBootstrapService,
    private schemeLinkService: SchemeLinkService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    const linkedSchemeId = this.route.snapshot.queryParamMap.get(SCHEME_LINK_PARAM);

    // The dialog shows the session's scheme, so it opens once a linked scheme has been applied.
    (linkedSchemeId ? this.schemeLinkService.open(linkedSchemeId) : Promise.resolve()).then(() => {
      this.dialogRef = this.dialog.open(LoadDialogComponent, { disableClose: true });
      return this.sessionBootstrapService.initialize();
    }).then(() => {
      this.dialogRef.close();
      // A linked /load entry is replaced so the back button can't reapply the link later.
      return this.sessionBootstrapService.redirectToDestination(true, !!linkedSchemeId);
    }).catch(err => this.commonService.errorHandler(err));
  }

  ngOnDestroy() {
  }
}
